/* eslint-disable react/prop-types */
import { UploadOutlined } from '@mui/icons-material';
import { FormControl, FormHelperText } from '@mui/material';
import { Button, Upload } from 'antd';
import { Field, useField, useFormikContext } from 'formik';

const FileField = ({ label, name, ...props }) => {
  const [field, helpers] = useField(name);
  const { getFieldMeta } = useFormikContext();
  const meta = getFieldMeta(field.name);

  return (
    <FormControl error={Boolean(meta.touched && meta.error)}>
      <Field
        name={name}
        render={({ fieldProps }) => (
          <Upload {...fieldProps} {...props}>
            <Button icon={<UploadOutlined />}>{label}</Button>
          </Upload>
        )}
      />
      {meta?.touched && meta?.error && (
        <FormHelperText mb="20px" color={'Red'}>
          {meta.error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default FileField;
